import React, { useEffect } from 'react';

import { Page } from '../../../ui/Page';

const DeleteAccount = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Page title={'Удаление аккаунта Spodial'}>
            <p>
                Удалить аккаунт Вы можете на странице настройки профиля
                пользователя в мобильном приложении или в веб версии продукта
                Spodial.
            </p>

            <p>
                <strong>Удаление в веб версии:</strong>
            </p>
            <ol>
                <li>
                    Перейдите по ссылке&nbsp;
                    <a
                        rel='noreferrer'
                        target='_blank'
                        href='https://spodial.com/auth/sign-in'
                    >
                        https://spodial.com/auth/sign-in
                    </a>
                    &nbsp;и авторизуйтесь под своими учётными данными Spodial.
                </li>
                <li>
                    Нажмите на иконку Вашего аккаунта в верхнем правом углу и
                    выберите в выпадающем меню пункт «Профиль».
                </li>
                <li>
                    Пролистайте страницу «Профиль» в самый низ и нажмите на
                    «Удалить аккаунт».
                </li>
                <li>
                    Во всплывающем окне поставьте галочку напротив «Я понимаю
                    последствия» и нажмите кнопку «Удалить».
                </li>
            </ol>

            <p>
                <strong>Удаление в мобильном приложении:</strong>
            </p>
            <ol>
                <li>
                    Запустите мобильное приложение Spodial и авторизуйтесь под
                    своими учётными данными Spodial.
                </li>
                <li>Выберите в боковом меню пункт «Профиль».</li>
                <li>
                    Пролистайте страницу «Профиль» в самый низ и нажмите на
                    «Удалить аккаунт».
                </li>
                <li>
                    Во всплывающем окне поставьте галочку напротив «Я понимаю
                    последствия» и нажмите кнопку «Удалить».
                </li>
            </ol>
        </Page>
    );
};

export default DeleteAccount;
